<template lang="pug">
  #ReservationIndex.container-width
    h5.text-center.py-3.letter-spacing-6 我的預約
    .button-row.row.no-gutters.mb-3
      .col-6
        b-button.button-first(
          block,
          :variant=" nowSelect === 'reserving' ? 'primary' : 'outline-primary bg-gray-light-2 text-black' ",
          @click="changeStatusHandler('reserving')"
        ) 申請預約
      .col-6
        b-button(
          block,
          :variant=" nowSelect === 'checked' ? 'primary' : 'outline-primary bg-gray-light-2 text-black' ",
          @click="changeStatusHandler('checked')"
        ) 完成預約
    .py-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="primary",
        v-for="(reserve,index) in nowSelect === 'reserving' ? unBindReservations : reservations",
        :key="reserve.reservation_id",
        body-class="p-0"
      )
        .row.position-relative.no-gutters(
          :class="{ 'no-gutters': reserve.status === 0, 'align-items-center': reserve.status === 0 }"
        )
          .col-12
            .p-3
              p.mb-1(v-if="reserve.reserve_type_name !== null") {{ reserve.reserve_type_name }}
              p.mb-1(v-if="reserve.activity_name !== null") {{ reserve.activity_name }}
            hr.m-0.border-white
            .p-3
              small.mb-2.d-block(v-if="reserve.activity_name !== null") 活動類型：{{ reserve.experience === 0 ? '到店體驗' : '線上體驗'}}
              small.mb-2.d-block 預約日期：{{ reserve.reserve_date }}
              small.mb-2.d-block 預約時間：{{ timeFormat(reserve.reserve_start_at) }}～{{ timeFormat(reserve.reserve_end_at) }}
              small.mb-2.d-block 預約專門店：{{ reserve.store_name }} {{ reserve.store_phone }}
              small.mb-2.d-block(
                v-if="reserve.status === 'cheked'"
              ) 專屬CA：{{ reserve.sa_preferred_name }}
              small.mb-2.d-block 參與人數：{{ reserve.companion_number }}
              small.mb-2.d-block 預約狀態：{{ reserve.status === 'reserving' ? '申請預約' : reserve.status === 'checked' ? '完成預約' : '-' }}
              small.mb-2.d-block 備註：{{ reserve.m_note }}
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

const moment = require('moment');

export default {
  name: 'ReservationIndex',
  components: {
    InfiniteLoading
  },
  data() {
    return {
      nowSelect: 'reserving',
      infiniteId: +new Date()
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('un_member_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    timeFormat(date) {
      return moment(date).format('HH:mm');
    },
    infiniteHandler($state) {
      const vm = this;
      if (vm.nowSelect === 'reserving') {
        vm.$store.dispatch('un_member_reservation/getUnbindReservationHandler', {
          current_page: vm.unBindPagination.current_page + 1,
          per_page: vm.unBindPagination.per_page,
          status: vm.nowSelect
        }).then(() => {
          if (vm.unBindPagination.current_page !== vm.unBindPagination.total_page) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else if (vm.nowSelect === 'checked') {
        vm.$store.dispatch('member_reservation/getReservationHandler', {
          current_page: vm.pagination.current_page + 1,
          per_page: vm.pagination.per_page,
          status: 'checked'
        }).then(() => {
          if (vm.pagination.current_page !== vm.pagination.total_page) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'reserving':
          if (vm.nowSelect === 'reserving') return;
          vm.nowSelect = 'reserving';
          vm.$store.commit('un_member_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checked':
          if (vm.nowSelect === 'checked') return;
          vm.nowSelect = 'checked';
          vm.$store.commit('member_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState({
      unBindReservations: (state) => state.un_member_reservation.reservations,
      unBindPagination: (state) => state.un_member_reservation.pagination,
      reservations: (state) => state.member_reservation.reservations,
      pagination: (state) => state.member_reservation.pagination
    })
  }
};
</script>

<style>

</style>
